export default {
  unexpected_error: "Napotkano niespodziewany problem.",
  nav: {
    firstStep: "pierwszy krok",
    navigate: "jak się poruszać",
    whyUs: "dlaczego veki?",
    nice: "jakie to ładne?",
    shop: "sklep",
    shopAll: "wszystko",
    shopContainers: "pojemniki",
    shopLarvals: "rynienki",
    shopOrganizers: "organizery",
    shopBoxes: "pudełka",
    shopCategoryKits: "zestawy",
    shopCategoryLabels: "etykiety",
    shopCategoryVouchers: "vouchery",
    organizeDrawer: "organizuj szufladę",
    genDimensions: "prześlij wymiary",
    genDesign: "zaprojektuj",
    materials: "rodzaje wykończeń",
    blog: "inspiracje",
    myAccount: "moje konto",
    contact: "kontakt"
  },
  user: {
    register: {
      email_blank: "Email użytkownika nie może być pusty.",
      password_blank: "Hasło użytkownika nie może być puste.",
      success: "Użytkownik został dodany pomyślnie.",
      user_exists: "Użytkownik o takiej nazwie / emailu już istnieje."
    },
    login: {
      username_blank: "Nazwa użytkownika nie może być pusta.",
      password_blank: "Hasło użytkownika nie może być puste.",
      invalid_username: "Podana nazwa użytkownika jest nieprawidła.",
      incorrect_password:
        "Podane hasło jest nieprawidłowe dla tego użytkownika.",
      unexpected_error: "Napotkano niespodziewany problem.",
      success: "Zalogowano pomyślnie."
    },
    unexpected_error: "Napotkano niespodziewany problem.",
    forgotten_pass: "Zapomniałeś hasła?"
  },
  contact: {
    contact_subject_blank: "Nie podano tematu.",
    contact_name_blank: "Nie podano imienia/nazwy.",
    contact_surname_blank: "Nie podano nazwiska.",
    contact_email_blank: "Nie podano adresu e-mail.",
    contact_message_blank: "Nie podano treści wiadomości.",
    form_success: "Wiadomość wysłana poprawnie.",
    form_failed: "Napotkano błąd podczas wysyłania wiadomości.",
    expired_captcha: "Captcha wygasła."
  },
  cart: {
    update: {
      success: "Pomyślnie zaktualizowano",
      errror: "Coś poszło nie tak przy aktualizacji"
    },
    shipping: {
      not_enough_data:
        "Podano nie wystarczającą ilość danych do obliczenia kosztu wysyłki."
    },
    coupon: {
      apply: {
        cart_empty: "Koszyk nie może być pusty.",
        code_blank: "Kod kuponu nie może być pusty.",
        code_invalid: "Podany kod kuponu jest nieprawidłowy.",
        code_used_up: "Podany kupon przekroczył limit użyć.",
        code_expired: "Podany kupon jest przeterminowany.",
        success: "Kupon dodany pomyślnie.",
        code_exists: "Podany kupon został już dodany.",
        error: "Napotkano niespodziewany problem."
      },
      remove: {
        code_blank: "Podany kupon nie istnieje.",
        success: "Kupon został usunięty pomyślnie.",
        code_not_removed: "Kupon nie został usunięty.",
        error: "Napotkano niespodziewany problem."
      }
    }
  },
  checkout: {
    click_here: "Kliknij tutaj",
    message: ", aby się zalogować/zarejestrować."
  },
  country: {
    PL: 'Polska',
    KZ: 'Kazachstan',
    AL: 'Albania',
    AD: 'Andora',
    AT: 'Austria',
    BE: 'Bielgia',
    BY: 'Białoruś',
    BA: 'Bośnia i Hercegowina',
    BG: 'Bułgaria',
    BG_BG_21: 'Smolan',
    HR: 'Chorwacja',
    ME: 'Czarnogóra',
    CZ: 'Czechy',
    DK: 'Dania',
    EE: 'Estonia',
    FI: 'Finlandia',
    FR: 'Francja',
    GR: 'Grecja',
    ES: 'Hiszpania',
    NL: 'Holandia',
    IE: 'Irlandia',
    IS: 'Islandia',
    LI: 'Liechtenstein',
    LT: 'Litwa',
    LU: 'Luksemburg',
    MK: 'Macedonia',
    MT: 'Malta',
    MC: 'Monako',
    DE: 'Niemcy',
    NO: 'Norwegia',
    PT: 'Portugalia',
    RU: 'Rosja',
    RO: 'Rumunia',
    SM: 'San Marino',
    RS: 'Serbia',
    CH: 'Szwajcaria',
    SE: 'Szwecja',
    SK: 'Słowacja',
    SI: 'Słowenia',
    TR: 'Turcja',
    VA: 'Watykan',
    GB: 'Wielka Brytania',
    HU: 'Węgry',
    IT: 'Włochy',
    LV: 'Łotwa',
    CA_NS: 'Nowa Szkocja'
  }
};